module.exports = __webpack_public_path__ + "img/Boss-4.3cceb3c1.png";